import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from 'react';

import { type TutorialDialogType } from './config';

interface TutorialDialogOverrides {
  callback?: () => void;
}

interface TutorialContextValue {
  activeDialog: TutorialDialogType | undefined;
  setActiveDialog: Dispatch<SetStateAction<TutorialDialogType | undefined>>;
  openDialog: (
    dialog: TutorialDialogType,
    overrides?: TutorialDialogOverrides,
  ) => void;
  closeDialog: () => void;
}

const TutorialContext = createContext({} as TutorialContextValue);

const useTutorial = (): TutorialContextValue => useContext(TutorialContext);

export { TutorialContext, useTutorial };
export type { TutorialContextValue, TutorialDialogOverrides };
